import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { withStyles, Grid } from '@material-ui/core'
import { useTranslation } from 'react-i18next'

import CardPaper from './CardPaper'
import { IconButton } from '../default'
import { CreateProductTableModal, EditProductTableModal, InsertProductModal } from '../modal'
import { useHistory } from 'react-router-dom'
import { ROUTER } from '../../class/constants'
import { MoveToInbox, PlaylistAdd, TableChart } from '@material-ui/icons'

const PRODUCT_MODALS = {
  INSERT: 1,
  CREATE_TABLE: 2,
  EDIT_TABLE: 3
}

function CardProduct({
  classes
}) {
  const { t } = useTranslation()
  const history = useHistory()

  const [currentModal, setCurrentModal] = useState(null)

  const loadInsertProductModal = () => {
    setCurrentModal(PRODUCT_MODALS.INSERT)
  }

  const loadCreateProductTableModal = () => {
    setCurrentModal(PRODUCT_MODALS.CREATE_TABLE)
  }

  const loadEditProductTableModal = () => {
    setCurrentModal(PRODUCT_MODALS.EDIT_TABLE)
  }

  const loadAddUserToProductTable = () => {
    return history.push({
      pathname: ROUTER.CUSTOMER_PRODUCT_TABLE.SEARCH
    })
  }

  return (
    <div className={classes.form}>
      <InsertProductModal
        onClose={() => setCurrentModal(null)}
        open={currentModal === PRODUCT_MODALS.INSERT} />
      <CreateProductTableModal
        onClose={() => setCurrentModal(null)}
        open={currentModal === PRODUCT_MODALS.CREATE_TABLE} />
      <EditProductTableModal
        onClose={() => setCurrentModal(null)}
        open={currentModal === PRODUCT_MODALS.EDIT_TABLE} />
      <Grid container xs={12} lg={8} xl={6} spacing={1} justifyContent='center'>
        <Grid item xs={6} className={classes.gridItem}>
          <CardPaper style={{ width: '100%', height: '100%' }}>
            <IconButton
              className={classes.formField}
              onClick={loadCreateProductTableModal}
              icon={TableChart}
            >
              {t('cards.products.btnCreateTable')}
            </IconButton>
          </CardPaper>
        </Grid>
        <Grid item xs={6} className={classes.gridItem}>
          <CardPaper style={{ width: '100%', height: '100%' }}>
            <IconButton
              className={classes.formField}
              onClick={loadEditProductTableModal}
              icon={TableChart}
            >
              {t('cards.products.btnEditTable')}
            </IconButton>
          </CardPaper>
        </Grid>
        <Grid item xs={6} className={classes.gridItem}>
          <CardPaper style={{ width: '100%', height: '100%' }}>
            <IconButton
              className={classes.formField}
              onClick={loadInsertProductModal}
              icon={PlaylistAdd}
            >
              {t('cards.products.btnInsert')}
            </IconButton>
          </CardPaper>
        </Grid>
        <Grid item xs={6} className={classes.gridItem}>
          <CardPaper style={{ width: '100%', height: '100%' }}>
            <IconButton
              className={classes.formField}
              onClick={loadAddUserToProductTable}
              icon={MoveToInbox}
            >
              {t('cards.products.btnAddUserToProductTable')}
            </IconButton>
          </CardPaper>
        </Grid>
      </Grid>
    </div>
  )
}

CardProduct.propTypes = {
  onSearch: PropTypes.func,
}

CardProduct.defaultProps = {
  onSearch: () => true
}

const styles = theme => ({
  header: {
    textAlign: 'center'
  },
  form: {
    display: 'flex',
    alignItems: 'center'
  },
  formField: {
    width: '100%',
    height: '100%'
  },
  gridItem: {
    display: 'flex',
    alignItems: 'flex-start'
  }
})

export default withStyles(styles)(CardProduct)